import React from 'react';

const SmallHeader = ({text}: {text: string, }) => {
    return (
        <p className="text-md font-semibold text-600 mb-0 mb-2">{text}</p>
    );
};

export default SmallHeader;
